const BagIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.345"
      height="22.642"
      viewBox="0 0 29.345 22.642"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5537"
            data-name="Rectangle 5537"
            width="29.345"
            height="22.642"
            fill="#707070"
          />
        </clipPath>
      </defs>
      <g id="Group_9444" data-name="Group 9444" transform="translate(0 -0.001)">
        <g
          id="Group_9443"
          data-name="Group 9443"
          transform="translate(0 0.001)"
          clipPath="url(#clip-path)"
        >
          <path
            id="Path_12173"
            data-name="Path 12173"
            d="M32.081,110.026a1.837,1.837,0,0,1-.532.3L18.6,114.835a2.258,2.258,0,0,1-1.5-.006l-12.6-4.5a1.67,1.67,0,0,1-.437-.235.2.2,0,0,0-.319.162c0,1.97,0,9.439,0,9.439A1.766,1.766,0,0,0,5.5,121.461H30.556a1.766,1.766,0,0,0,1.766-1.766l0-9.557a.145.145,0,0,0-.237-.113"
            transform="translate(-3.356 -98.82)"
            fill="#707070"
          />
          <path
            id="Path_12174"
            data-name="Path 12174"
            d="M27.651,23.176H1.694A1.722,1.722,0,0,0,0,24.924V29.83a1.781,1.781,0,0,0,.384,1.108,1.691,1.691,0,0,0,.756.545l12.6,4.5a2.259,2.259,0,0,0,1.5.006l12.953-4.511a1.692,1.692,0,0,0,.768-.549,1.781,1.781,0,0,0,.384-1.108v-4.9a1.722,1.722,0,0,0-1.694-1.748"
            transform="translate(0 -20.822)"
            fill="#707070"
          />
          <path
            id="Path_12175"
            data-name="Path 12175"
            d="M100.78,1.711H90.774a.5.5,0,0,1-.5-.5V.5a.5.5,0,0,1,.5-.5H100.78a.5.5,0,0,1,.5.5v.713a.5.5,0,0,1-.5.5"
            transform="translate(-81.105)"
            fill="#707070"
          />
        </g>
      </g>
    </svg>
  )
}

export default BagIcon
